import { Layout, CountsValue } from "components"
export const CountValueData = () => {
 return (
  <Layout>
   <CountsValue />
  </Layout>
 )
}
